import { PageLink, PageTitle } from '_metronic/layout/core';
import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { NominaView } from './components/nominaView';


const NominaPage: FC = () => {
  let location = useLocation();
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Nómina',
      path: location.pathname,
      isSeparator: false,
      isActive: true,
    },
    {
      title: 'Mi nómina',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Nómina</PageTitle>
      <NominaView/>
    </>
  );
};

export {NominaPage}